import { faEdit, faPlusSquare } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { camelCase } from "lodash-es";
import React, { useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { OPTIONS_DATA_MAPPER } from "../../utils";
import AddToolTip from "../AddToolTip";
import "../../styles/components/BankDetails.scss";
import { isEmpty, get, isMatch, pick } from "lodash";
import { useDeepEffect } from "../../abstracts";

const keys = [
  "nameOfTheFinancialInstitution",
  "accountHolderName",
  "typeOfAccount",
  "checkingSavingsAccountNumber",
  "abaRoutingNumberforBankOfCreditUnion",
];

const BankDetails = (props) => {
  const {
    defaultBankInformation, //
    bankInformationDetails, //
    setBankInformationDetails, //
    bankList = [],
    checked,
    bankAdded,
    setBankAdded,
    setBankSlideOpen, //
    responseModel = [],
    index, //
    module, //
    data,
    setFieldValue, //,
    isLoanRequest, //
    selectedIndex = 0,
    isRepayment,
    setIsRepaymentBankInfo,
  } = props;
  const [selectedBank, setSelectedBank] = useState(selectedIndex);
  const checkIfDefault = (apiBank) => {
    if (bankInformationDetails.length >= 1) {
      if (isMatch(pick(bankInformationDetails[0], keys), pick(apiBank, keys)))
        return true;
    }
    return false;
  };

  useDeepEffect(() => {
    if (isLoanRequest) {
      setSelectedBank(selectedIndex);
      !isRepayment
        ? setFieldValue("bank", bankInformationDetails[selectedIndex])
        : setFieldValue(
            "repaymentBankDetail",
            bankInformationDetails[selectedIndex]
          );
    }
  }, [selectedIndex]);

  useDeepEffect(() => {
    if (
      !isEmpty(responseModel) &&
      !isEmpty(responseModel[0]?.bankInformation) &&
      !isLoanRequest
    ) {
      if (!checkIfDefault(responseModel[0]?.bankInformation)) {
        if (!isEmpty(bankList) && !isEmpty(bankList[index])) {
          bankList[index] = [
            bankList[index][0],
            responseModel[0]?.bankInformation,
          ];
          setSelectedBank(1);
        } else {
          bankList[index] = [responseModel[0]?.bankInformation];
        }
        setBankInformationDetails(bankList);
      }
    }
  }, [responseModel]);

  const onBankChange = (val, ind, isRepayment) => {
    setSelectedBank(ind);
    if (!isLoanRequest) setFieldValue(`${module}.${index}.bank`, val);
    else
      isRepayment
        ? setFieldValue(`repaymentBankDetail`, val)
        : setFieldValue(`bank`, val);
  };

  return (
    <div className="W-90">
      <div className="d-flex flex-row mb-1">
        <p className="mb-0 p-0 ft-14 fw-400 Grey-Color">Bank Details</p>
        &nbsp;&nbsp;&nbsp;
        {defaultBankInformation != null
          ? bankInformationDetails.length <= 1 && (
              <div
                onClick={() => {
                  if (isLoanRequest) {
                    setBankSlideOpen(true);
                    setIsRepaymentBankInfo(isRepayment);
                  } else {
                    let tempBankList = bankList;
                    tempBankList[index] = [...tempBankList[index], {}];
                    setBankInformationDetails(tempBankList);
                    setBankSlideOpen(index);
                  }
                }}
                className="ft-14 fw-400 Light-Blue"
              >
                <FontAwesomeIcon icon={faPlusSquare} className="ft-14 fw-300" />{" "}
                Add
              </div>
            )
          : bankInformationDetails.length === 0 && (
              <div
                onClick={() => {
                  if (isLoanRequest) {
                    setBankSlideOpen(true);
                    setIsRepaymentBankInfo(isRepayment);
                  } else setBankSlideOpen(index);
                }}
                className="ft-14 fw-400 Light-Blue"
              >
                <FontAwesomeIcon icon={faPlusSquare} className="ft-14 fw-300" />{" "}
                Add
              </div>
            )}
      </div>
      <Form.Group>
        {bankInformationDetails?.map((bank, ind) => {
          if (
            //bank.accountHolderName &&
            bank.nameOfTheFinancialInstitution &&
            bank.abaRoutingNumberforBankOfCreditUnion != 0 &&
            bank.checkingSavingsAccountNumber != 0
          ) {
            return (
              <div className="mb-15">
                <div
                  className={`${
                    ind == selectedBank
                      ? "border-blue background-blue"
                      : "border-grey background-white"
                  }${"d-flex flex-row bank-card"}`}
                  style={{ cursor: "pointer" }}
                  onClick={() => onBankChange(bank, ind, isRepayment)}
                >
                  <input
                    className="marg-right-25"
                    checked={selectedBank == ind}
                    type="radio"
                    name={
                      isRepayment
                        ? `[${module}]${index}.repaymentBankDetail`
                        : `[${module}]${index}.bank`
                    }
                    value={""}
                  />

                  <div className="d-flex flex-row w-100">
                    <div className="d-flex flex-col w-25">
                      <p className="fw-400 ft-12 Grey-Color Account-Holder">
                        Account Holder
                      </p>
                      <p className="ft-16 fw-500 Dark-Grey-Color Account-Holder">
                        <AddToolTip name={bank.accountHolderName} />
                      </p>
                    </div>
                    <div className="d-flex flex-col w-25">
                      <p className="fw-400 ft-12 Grey-Color Account-Holder">
                        Bank Name
                      </p>
                      <p className="ft-16 fw-500 Dark-Grey-Color Account-Holder">
                        <AddToolTip name={bank.nameOfTheFinancialInstitution} />
                      </p>
                    </div>
                    <div className="d-flex flex-col w-25">
                      <p className="fw-400 ft-12 Grey-Color Account-Holder">
                        Routing No
                      </p>
                      <p className="ft-16 fw-500 Dark-Grey-Color Account-Holder">
                        <AddToolTip
                          name={bank.abaRoutingNumberforBankOfCreditUnion}
                        />
                      </p>
                    </div>
                    <div className="d-flex flex-col w-25">
                      <p className="fw-400 ft-12 Grey-Color Account-Holder">
                        Account No
                      </p>
                      <p className="ft-16 fw-500 Dark-Grey-Color Account-Holder">
                        <AddToolTip name={bank.checkingSavingsAccountNumber} />
                      </p>
                    </div>
                  </div>
                </div>
                <div>
                  {!isEmpty(defaultBankInformation) && ind === 1 && (
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        if (isLoanRequest) {
                          setBankSlideOpen(true);
                          setIsRepaymentBankInfo(isRepayment);
                        } else setBankSlideOpen(index);
                      }}
                      className="ft-14 fw-400 light-blue"
                    >
                      <FontAwesomeIcon icon={faEdit} className="ft-14 fw-300" />{" "}
                      Edit
                    </div>
                  )}
                  {isEmpty(defaultBankInformation) && ind === 0 && (
                    <div
                      onClick={() => {
                        if (isLoanRequest) {
                          setBankSlideOpen(true);
                          setIsRepaymentBankInfo(isRepayment);
                        } else setBankSlideOpen(index);
                      }}
                      className="ft-14 fw-400 light-blue cursor-pointer"
                    >
                      <FontAwesomeIcon
                        icon={faEdit}
                        className="ft-14 fw-300 cursor-pointer"
                      />{" "}
                      Edit
                    </div>
                  )}
                </div>
              </div>
            );
          }
        })}
      </Form.Group>
    </div>
  );
};

export default BankDetails;
